import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';
import { ApiService } from '../../shared/services/api.service';
import { TableActions, tableReducer, TableStreamData } from '../shared/rxjs/table-reducer';
import { AuthTokenService } from '../shared/services/auth-token.service';
import { PpbApiService } from '../shared/services/ppb-api.service';

@Injectable({
  providedIn: 'root'
})
export class RegistrationCodesService {

  private registrationCodes = new Subject<TableStreamData<any>>();
  private canGenerateNewCode = new BehaviorSubject<boolean>(false);

  // tslint:disable-next-line: member-ordering
  registrationCodes$ = this.registrationCodes
    .pipe(
      tableReducer(),
      publishReplay(1),
      refCount()
    )

  // tslint:disable-next-line: member-ordering
  canGenerateNewCode$ = this.canGenerateNewCode

  constructor(
    private api: PpbApiService,
    private oldApi: ApiService,
    private authTokenService: AuthTokenService
  ) { }

  getRegistraionCodes(): void {
    const params = new HttpParams({
      fromObject: {
      }
    });
    this.api.get<any>('/api/v1/codes', params)
      .subscribe(res => {
        this.canGenerateNewCode.next(res.canCreateNewCode);
        this.registrationCodes.next({
          payload: res.registrationCodes,
          action: TableActions[TableActions.ADD],
        });
      });
  }

  generateNew(): void {
    const params = new HttpParams({
      fromObject: {
      }
    });
    this.api.put<any>('/api/v1/codes', {}, params)
      .subscribe(res => {
        this.canGenerateNewCode.next(res.canCreateNewCode);
        this.registrationCodes.next({
          payload: res.registrationCodes,
          action: TableActions[TableActions.ADD],
        });
      });
  }

  deleteCode(id: number): void {
    const params = new HttpParams({
      fromObject: {
      }
    });
    this.oldApi.delete<any>('/api/v1/codes/' + id, params, this.addAuth(new HttpHeaders()))
      .subscribe(res => {
        this.canGenerateNewCode.next(res.canCreateNewCode);
        this.registrationCodes.next({
          payload: res.registrationCodes,
          action: TableActions[TableActions.ADD],
        });
      });
  }

  private addAuth(headers: HttpHeaders): HttpHeaders {
    if (this.authTokenService.checkAuth()) {
      headers = headers.append(
        'Authorization', this.authTokenService.getAccessToken())
    }

    return headers;
  }

}
